// extracted by mini-css-extract-plugin
export default {"products":"Sw-z","card":"Tw-z","oosMessaging":"Uw-z"};